<template>
  <section id="how-to-buy" >
    <div class="main-title">Chart Tracking</div>

    <div>
      <div class="row" style="margin-left: 0px; margin-right: 0px" v-scrollanimation>
        <div class="list-item-hover">
          <a class="item-hover" href="https://dex.guru/token/0x68590a47578e5060a29fd99654f4556dbfa05d10-bsc" target="_blank">
            <div class="item-icon">
              <img :src="require('@/assets/images/dexguru.jpeg')" />
            </div>
            <div class="item-content">
              <div class="item-title">Dex.guru</div>
              <div class="item-desc">Tracking in Dex.guru</div>
            </div>
          </a>

          <a class="item-hover" href="https://poocoin.app/tokens/0x68590a47578e5060a29fd99654f4556dbfa05d10" target="_blank">
            <div class="item-icon">
              <img :src="require('@/assets/images/poocoin.png')" />
            </div>
            <div class="item-content">
              <div class="item-title">PooCoin</div>
              <div class="item-desc">Price tracking in PooCoin</div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Chart",
  components: {},
  props: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
